import Axios from "axios";
import {
    SET_PRD_PRODUCTION_LIST,
    UNSET_PRD_PRODUCTION_LIST,
} from "@/store/mutation-types";
import { 
    prdProductionResource,
} from "@/store/api";

const state = {
    getPrdProductionList: [],
};

const getters = {
    getPrdProductionList(state) {
        return state.getPrdProductionList;
    },
};

const mutations = {
    [SET_PRD_PRODUCTION_LIST](state, data) {
        state.getPrdProductionList = data;
    },
    [UNSET_PRD_PRODUCTION_LIST](state) {
        state.getPrdProductionList = [];
    },
};

const actions = {
    savePrdProduction({ commit }, data) {
        commit("SET_LOADING", {color: "primary"});
        return new Promise((resolve, reject) => {
            Axios.post(prdProductionResource, data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
        });
    },

    updatePrdProduction({ commit }, data) {
        commit("SET_LOADING", {color: "primary"});
        return new Promise((resolve, reject) => {
            Axios.put(`${prdProductionResource}/${data.id}`, data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
        });
    },

    getPrdProductionList({ commit }) {
        return new Promise((resolve, reject) => {
        Axios.get(prdProductionResource)
            .then(function (response) {
            commit('SET_PRD_PRODUCTION_LIST', response.data.data);
            resolve(response);
            })
            .catch(function (error) {
            commit('UNSET_PRD_PRODUCTION_LIST');
            reject(error);
            });
        });
    },

    getPrdProductionById({ commit }, data) {
        const fullUrl = `${prdProductionResource}/${data}`;
            commit("SET_LOADING", { color: "primary" });
            return new Promise((resolve, reject) => {
                Axios.get(fullUrl)
                    .then((response) => {
                    resolve(response.data); 
                })
                    .catch((error) => {
                    console.error("API Error:", error.response?.data || error.message);
                    reject(error);
                })
                    .finally(() => {
                    commit("UNSET_LOADING");
                });
            }
        );
    },
};

export default {
  state,
  getters,
  actions,
  mutations,
};

